module.exports = __webpack_public_path__ + "img/image_3.58ef851c.jpg";